/**
 * @generated SignedSource<<88afa5a9026579ee930340b8ff68e810>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreatorsSidebar_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"formatCreatorsAttribute_viewer">;
  readonly " $fragmentType": "CreatorsSidebar_viewer";
};
export type CreatorsSidebar_viewer$key = {
  readonly " $data"?: CreatorsSidebar_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreatorsSidebar_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreatorsSidebar_viewer",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "formatCreatorsAttribute_viewer",
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "names",
              "value": [
                "creatorNationality",
                "creatorStyle"
              ]
            }
          ],
          "concreteType": "CreatorProp",
          "kind": "LinkedField",
          "name": "creatorProperties",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "propertyName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "urlLabel",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": "creatorProperties(names:[\"creatorNationality\",\"creatorStyle\"])"
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "03af6f9517da45c9d2668a45d0e9d0e4";

export default node;
